import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_BusinessInfo = _resolveComponent("BusinessInfo", true)!
  const _component_BottomFormActionButtons = _resolveComponent("BottomFormActionButtons")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      経験・転職意欲\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      tag: "div",
      class: "pt-2 pb-4 mx-3"
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(_component_StepBar, {
          maxValue: 4,
          currentValue: 4,
          class: "mb-3"
        }),
        _createTextVNode(),
        _createVNode(_component_BusinessInfo, {
          modelValue: _ctx.inputValues,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues) = $event))
        }, null, 8, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_BottomFormActionButtons, {
          submitButtonText: "登録する",
          skipButtonText: "スキップする",
          onSubmit: ($event: any) => (handleSubmit(_ctx.onSubmit)),
          onSkip: _ctx.onClickSkip
        }, null, 8, ["onSubmit", "onSkip"])
      ]),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}